import Dialog from "@/components/Dialog";
import Button from "@/components/Button";

interface RemoveStaffConfirmationDialogProps {
  open: boolean;
  onClosed: () => void;
  onConfirm: () => void;
  isSubmitting: boolean;
}

export const RemoveStaffConfirmationDialog = ({
  open,
  onClosed,
  onConfirm,
  isSubmitting
}: RemoveStaffConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClosed={onClosed}
      headline="Remove Staff from Event"
      className="sm:max-w-[423px] p-6 pr-2"
      actions={
        <>
          <Button variant="text" onClick={onClosed} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            variant="filled"
            onClick={onConfirm}
            disabled={isSubmitting}
            theme="error"
            icon={isSubmitting ? "progress_activity" : "delete"}
            iconClassName={isSubmitting ? "animate-spin w-6 h-6 !block" : undefined}
          >
            Remove
          </Button>
        </>
      }
    >
      <p>Are you sure you want to remove this staff member from this event?</p>
    </Dialog>
  );
};
